import { Context } from '@nuxt/types/app';
import config from '@/config';

export default ({ store }: Context) => {
    const countryCodes = config.dailyChatAllowedCountryCodes.split(',');
    const isDailyChatEnabled =
        config.featureToggle.useDailyChat && countryCodes.includes(store.state.main.locale.split('-')[1].toUpperCase());
    store.dispatch('main/setIsDailyChatEnabled', isDailyChatEnabled);
};
